export default {"src":"/_next/static/media/eco-friendly.81b56b9f.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};